import React from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton } from '@mui/material'
import { VolumeOff, VolumeUp } from '@mui/icons-material'

export const Volume = observer((props: any) => {
  const { muted, onPress, color } = props
  return (
    <IconButton
      data-qat="sound-toggle"
      aria-label={muted ? 'music off' : 'music on'}
      role="switch"
      onClick={onPress}
    >
      {muted ? <VolumeOff htmlColor={color} /> : <VolumeUp htmlColor={color} />}
    </IconButton>
  )
})
